import {Arguments} from './Arguments';
import {PostToJava, RealtimeGetMethod} from './ApiMethod';
import {convertToCamelCase} from './ConversionMethod';
import OnFinishMethod from './OnFinishMethod';

// 为了实现通用接口，根据向后端发送的接口地址匹配对应的数据库，进而在 t_sequences 表中找到对应数据库中需要自增的字段名称
const GetAutoIncrementId = (postApi) => {
	const apiToDB =
		{
			addPartyMember: 'consortium_branch_member_info',
			addResearcherInformation: 'mbsk_research_people_info',
			addEmployeeInformation: 'mbsk_work_people_info',
			addKeyActivity: 'organization_activity_info',
			addOtherActivity: 'organization_common_activity_info',
			addSocietyInformation: 'organization_info',
			addMemberPersonal: 'organization_member_info',
			addMemberCompany: 'organization_member_unit_info',
			addSocietyRecognition: 'organization_prize_info',
			addYearlyRecognition: 'organization_year_check_info',
			addMeetingDelegate: 'meeting_member_info',
			addUser: 'user_info',
			addPartyActivity: 'branch_activity_info',
			addBaseRecognition: 'branch_commend_info',
			addBranchActivity: 'branch_common_activity_info',
			addBranchPartyBranchMember: 'branch_party_branch_member_info',
			addBranchPartyMember: 'branch_party_member_info',
			addEvaluateInformation: 'branch_party_check_info',
			addBranchParty: 'branch_party_member_info',
			addMeetingNotice: 'temp_meeting_info',
			addPolicyRegulation: 'policy_info',
			addInformation: 'notification_info',
		};
	const apiMethodName = postApi.match(/!(.+).do/)[1];
	const dbName = apiToDB[apiMethodName];
	const tSequencesApi = Arguments.host + '/society_organization/id/generator/api!incrementId.do';
	return RealtimeGetMethod(tSequencesApi).then(resultList => {
		return resultList.filter(item => item.seqName.includes(dbName));
	});
};

// 其他地方调用该方法时需要将 id 之外的字段提前放入 data 中，注意这里面的 postApi 为字符串形式，为新增数据的接口
export const AddFormDataMethod = (data, postApi) => {
	// 新增数据，需要将当前表单中的数据添加 id 值，由后台生成自增值
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();
	GetAutoIncrementId(postApi).then(tSequences => {
		// 除了新增用户外，其他提交的数据中 organizationId 为当前登录用户的 organizationId，但新增用户操作会覆盖这个已有值，因此不冲突
		let postData = {...data, organizationId: orgId};
		// 考虑同一个数据库有多个 id 需要自增，如新增用户操作
		const promises = tSequences.map(sequence => {
			const fieldName = sequence.seqName;
			const fieldIdName = convertToCamelCase(fieldName.split('.')[1]);
			const refreshIdApi = Arguments.host + '/society_organization/id/generator/api!refreshTSequences.do';
			// 获取最新的 id 值
			return PostToJava(refreshIdApi, {fieldName: fieldName}).then(res => {
				if (res?.data.code === 1) {
					// 得到最新的 id 值cd
					const recentId = res.data.result.data.curVal;
					postData = {...postData, [fieldIdName]: recentId};
				} else {
					// console.log(`${fieldName} 数据更新失败.`)
				}
			});
		});
		// 等得到最终的 postData 再执行
		Promise.all(promises).then(() => {
			// console.log("postData     ", postData);
			OnFinishMethod(postData, [postApi]);
		});
	});
};